import http from "../../config/http";
import { GET_NOTIFICACIONES, MODIFICAR_NOTIFICACION,GET_NOTIFICACIONESCENTRAL } from "../endpoints";

const getAllNotificaciones = (codigoAfiliado) => {
  let configuration = {
    headers: {"Authorization": "Bearer " + localStorage.getItem("token")}
  }
  return http.get(
    `ClienteNotificacion/${GET_NOTIFICACIONES}?IdAfiliado=${codigoAfiliado}`,configuration
  );
};

const postModificacionNotificacion = (notificacion) => {
  let configuration = {
    headers: {"Authorization": "Bearer " + localStorage.getItem("token")}
  }
  return http.post(
    `ClienteNotificacion/${MODIFICAR_NOTIFICACION}`,
    notificacion,
    configuration
  );
};

const postConsNotificacion = (contrato, regimen="", plan="", numeroDePagina = 0,registroPorPagina = 10) => {
  let configuration = {
    headers: {"Authorization": "Bearer " + localStorage.getItem("token")}
  }

  const body = {
    contrato:contrato,
    regimen: regimen,
    plan: plan,
    numeroDePagina: numeroDePagina,
    registroPorPagina: registroPorPagina,
  }

  return http.post(
    `ClienteNotificacion/${GET_NOTIFICACIONESCENTRAL}`,
    body,
    configuration
  );
}

export { getAllNotificaciones, postModificacionNotificacion, postConsNotificacion };
